import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Page, PageHeader } from "../../../components/ui";
import { createChannelGeneralContent } from "../../../store/actions/uploadMediaAction";
import ChannelForm, { channelFormValues, channelPayload } from "./ChannelForm";

const AddChannel = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const handleCreate = async (values) => {
    const created = await dispatch(
      createChannelGeneralContent(channelPayload(values, { withBanner: true }))
    );
    const id = created?.savedChannel?._id;
    if (!id) {
      toast.error(t("Error In General Content"));
      return;
    }
    toast.success(t("Channel Info Submitted Successfully!"));
    // The stream URL and key are shown on the edit page.
    history.push(`/dashboard/update-channel/${id}`);
  };

  return (
    <Page>
      <PageHeader title={t("Add Channel")} />
      <ChannelForm
        initialValues={channelFormValues(null)}
        withBanner
        onSubmit={handleCreate}
        submitLabel={t("submit")}
        cancelPath="/dashboard/channel-list"
      />
    </Page>
  );
};

export default AddChannel;
